import React from 'react';
import { UID } from 'react-uid';

const MCFreeIcon = ({
  title = 'MC Free',
  decorative = true,
  className,
  size,
}) => (
  <UID>
    {(uid) => (
      <div style={{ width: size, height: size }} className={className}>
        <svg
          role="img"
          aria-hidden={decorative}
          aria-labelledby={uid}
          width="262"
          height="130"
          viewBox="0 0 262 130"
        >
          <title id={uid}>{title}</title>
          <defs>
            <linearGradient
              id="a"
              x1="88.281%"
              x2="157.989%"
              y1="73.513%"
              y2="32.379%"
            >
              <stop offset="0%" stopColor="#F5F9FF" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="b"
              x1="96.875%"
              x2="137.057%"
              y1="83.458%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="c"
              x1="110.286%"
              x2="157.989%"
              y1="72.535%"
              y2="12.284%"
            >
              <stop offset="0%" stopColor="#F5F9FF" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="d"
              x1="79.19%"
              x2="104.427%"
              y1="83.842%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="e"
              x1="62.18%"
              x2="76.947%"
              y1="99.088%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd">
            <g fill="#EBF2FF" opacity=".5">
              <rect width="222.453" height="47.634" rx="23.76" />
              <rect
                width="222.453"
                height="82.366"
                x="39.547"
                y="47.634"
                rx="41.085"
              />
            </g>
            <g fillRule="nonzero" transform="translate(45.48 10.916)">
              <path
                fill="#EA5188"
                d="M59.702 25.802a7.598 7.598 0 0 1-3.884-1.07.825.825 0 0 1-.452-.734c0-.308.174-.591.45-.734a.842.842 0 0 1 .867.059 5.906 5.906 0 0 0 7.225-.938 5.752 5.752 0 0 0 .714-7.177.819.819 0 0 1-.077-.852.836.836 0 0 1 .727-.463c.31-.008.6.155.752.423a7.376 7.376 0 0 1 .29 7.602 7.535 7.535 0 0 1-6.612 3.884zM124.568 85.344a1.01 1.01 0 0 1-.891-.543 11.23 11.23 0 0 0-6.349-5.494.975.975 0 0 1-.1-1.807c.239-.112.512-.126.76-.04 3.249 1.122 5.928 3.437 7.472 6.457a.989.989 0 0 1-.892 1.427z"
              />
              <path
                fill="#D6E2F5"
                d="M136.446 97.787a.575.575 0 0 1-.133.55c-1.048 1.04-1.668 2.52-1.73 4.131-.013.303-.244.522-.516.489a.51.51 0 0 1-.34-.201.623.623 0 0 1-.128-.404c.073-1.895.801-3.638 2.033-4.86.199-.193.51-.162.7.069a.615.615 0 0 1 .114.226z"
              />
              <path
                fill="#35DEB3"
                d="M50.802 73.435l-1.368 3.97 4.943-2.298z"
              />
              <path fill="#C8D7EE" d="M141.842 81.417l4.044-1.08-4.662-2.83z" />
              <path fill="#35DEB3" d="M46.79 17.863l.667-4.962-5.932 4.095z" />
              <ellipse
                cx="43.996"
                cy="30.267"
                fill="#B938D1"
                rx="2.472"
                ry="2.481"
              />
              <ellipse
                cx="22.245"
                cy="26.298"
                fill="#C8D7EE"
                rx="1.483"
                ry="1.489"
              />
              <ellipse cx="50.423" cy="52.595" fill="#EA5188" rx="1" ry="1" />
              <ellipse cx="139.404" cy="59.542" fill="#35DEB3" rx="1" ry="1" />
              <ellipse
                cx="121.113"
                cy="64.008"
                fill="#B938D1"
                rx="2.472"
                ry="2.481"
              />
              <path
                fill="url(#a)"
                d="M2.34 69.348a1.597 1.597 0 0 1-1.36-.746 1.627 1.627 0 0 1 .488-2.25l50.044-28.388a1.628 1.628 0 0 1 2.25.507 1.64 1.64 0 0 1-.505 2.258L3.222 69.099c-.266.162-.57.248-.882.25z"
              />
              <path
                fill="url(#b)"
                d="M39.697 102.521a1.644 1.644 0 0 1 .13-1.954l37.74-42.387a1.627 1.627 0 0 1 2.221-.08c.647.562.752 1.53.241 2.219L42.29 102.706c-.206.233-.47.406-.765.5a1.63 1.63 0 0 1-1.828-.685z"
              />
              <path
                fill="url(#c)"
                d="M28.866 79.326a1.648 1.648 0 0 1 .42-1.921L70.404 42.16a1.598 1.598 0 0 1 1.635-.404 1.653 1.653 0 0 1 .473 2.878l-41.11 35.253c-.235.202-.524.331-.83.371a1.6 1.6 0 0 1-1.706-.933z"
              />
              <path
                fill="url(#d)"
                d="M76.248 93.023a1.654 1.654 0 0 1-.243-1.91l19.58-28.724a1.581 1.581 0 0 1 1.4-1.003 1.572 1.572 0 0 1 1.47.888 1.647 1.647 0 0 1-.18 1.739L78.721 92.727a1.562 1.562 0 0 1-.619.625 1.56 1.56 0 0 1-1.855-.329z"
                transform="rotate(-4 87.215 77.454)"
              />
              <path
                fill="url(#e)"
                d="M86.64 112.04a1.626 1.626 0 0 1-.917-2.084l21.056-45.4a1.618 1.618 0 0 1 2.083-.941 1.61 1.61 0 0 1 .944 2.075l-21.056 45.4a1.605 1.605 0 0 1-1.54 1.051 1.84 1.84 0 0 1-.57-.1z"
              />
              <path
                fill="#84A5FF"
                d="M132.483 0l-46.17 59.542-10.185-20.909-21.75-2.552z"
              />
              <path
                fill="#1F4ED2"
                d="M132.483 0l-46.17 59.542-10.185-20.909z"
              />
              <path fill="#00173E" d="M86.313 59.542l8.6-11.043-10.875-6.82z" />
              <path
                fill="#C6D5FF"
                d="M112.748 59.542L83.05 42.066 132.483 0z"
              />
            </g>
            <ellipse
              cx="13.347"
              cy="63.015"
              fill="#F5F9FF"
              rx="13.347"
              ry="13.397"
            />
            <ellipse
              cx="26.694"
              cy="89.313"
              fill="#F5F9FF"
              rx="6.921"
              ry="6.947"
            />
            <ellipse
              cx="248.653"
              cy="25.305"
              fill="#F5F9FF"
              rx="13.347"
              ry="13.397"
            />
          </g>
        </svg>
      </div>
    )}
  </UID>
);

export default MCFreeIcon;
